import api from './api';

export type CategoriaEmbaixador = 'estudante' | 'empreendedor' | 'criador_conteudo' | 'outro';
export type TierEmbaixador = 'bronze' | 'prata' | 'ouro';
export type EstadoEmbaixador = 'ativo' | 'inativo' | 'suspenso';

export interface Embaixador {
  id: number;
  user_id: string;
  categoria: CategoriaEmbaixador;
  tier: TierEmbaixador;
  estado: EstadoEmbaixador;
  data_inicio: string;
  data_fim: string | null;
  pontos_mensais: number;
  early_access: 0 | 1;
  badge_icone: string;
  notas: string | null;
  created_at: string;
  username: string;
  email: string;
  nome: string;
  meses_pagos?: number;
  pontos_acumulados?: number;
}

export interface EmbaixadorStats {
  total: number;
  ativos: number;
  suspensos: number;
  pontos_mes_atual: number;
  por_categoria: Array<{ categoria: string; n: number }>;
}

export interface EmbaixadorPayload {
  user_id?: string;
  categoria?: CategoriaEmbaixador;
  tier?: TierEmbaixador;
  estado?: EstadoEmbaixador;
  data_inicio?: string;
  data_fim?: string;
  pontos_mensais?: number;
  early_access?: boolean;
  badge_icone?: string;
  notas?: string;
}

export interface ProcessMonthlyResult {
  periodo: string;
  ativos_elegiveis: number;
  processados: number;
  ja_processados_antes: number;
  total_pontos_creditados: number;
}

class MarketingEmbaixadoresService {
  async setup() { await api.post('/admin/marketing/embaixadores/setup'); }
  async stats(): Promise<EmbaixadorStats> {
    const res = await api.get('/admin/marketing/embaixadores/stats');
    return res.data.data;
  }
  async list(filters?: { categoria?: string; estado?: string; search?: string }): Promise<Embaixador[]> {
    const qs = new URLSearchParams();
    if (filters?.categoria) qs.append('categoria', filters.categoria);
    if (filters?.estado) qs.append('estado', filters.estado);
    if (filters?.search) qs.append('search', filters.search);
    const res = await api.get(`/admin/marketing/embaixadores?${qs}`);
    return res.data.data || [];
  }
  async create(payload: EmbaixadorPayload): Promise<Embaixador> {
    const res = await api.post('/admin/marketing/embaixadores', payload);
    return res.data.data;
  }
  async update(id: number, payload: EmbaixadorPayload) {
    await api.put(`/admin/marketing/embaixadores/${id}`, payload);
  }
  async remove(id: number) {
    await api.delete(`/admin/marketing/embaixadores/${id}`);
  }
  async processMonthly(periodo?: string): Promise<ProcessMonthlyResult> {
    const res = await api.post('/admin/marketing/embaixadores/process-monthly', periodo ? { periodo } : {});
    return res.data.data;
  }
}

export default new MarketingEmbaixadoresService();
